import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientMedicalTechnologyId } from '@app/icare/entities/patient/schema/PatientMedicalTechnology'
import { PatientMedicalTechnologyOverview } from '@app/icare/routes/_app/patienten/$id/_edit/_medicalTechnology/-components/PatientMedicalTechnologyOverview'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_medicalTechnology/medizintechnikversorger/$relation')({
  params: entityParams({ id: PatientId, relation: PatientMedicalTechnologyId }),
  component: RouteComponent,
})

function RouteComponent() {
  const { id, relation } = Route.useParams()

  return <PatientMedicalTechnologyOverview patientId={id} relationId={relation} />
}
